// extracted by mini-css-extract-plugin
module.exports = {"table":"Scores_table__1UrDJ","table__header":"Scores_table__header__18tzs","table__row":"Scores_table__row__hpmcJ","dark":"Scores_dark__1lvmx"};